<div class="revocation-edit__row" id="revocationEditHeader">
  <div class="revocation-edit__header col-12">
    <h3 class="revocation-edit__title"
        [innerHTML]="translationService.getTranslation('revocation_edit_title')"></h3>
  </div>

  <div class="revocation-edit__errors col-12">
    <app-general-errors [errors]="errorsArr"></app-general-errors>
  </div>

  <div class="revocation-edit__spinner" style="text-align: center;" *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>

  <ng-container *ngIf="!isLoading && subscription">
    <mat-card class="revocation-edit__sub-card mt-3" appearance="outlined">
      <mat-card-content class="revocation-edit__sub-content m-3">
        <mat-card-title class="revocation-edit__sub-title">{{ subscription.productDescription }}</mat-card-title>
        <mat-card-subtitle
          *ngIf="subscription.subId"
          [innerHTML]="translationService.getTranslation('order_id') + ': ' + subscription.subId">
        </mat-card-subtitle>
        <mat-card-subtitle
          *ngIf="subscription.variantDescription"
          [innerHTML]="translationService.getTranslation('order_edition') + ': ' + subscription.variantDescription">
        </mat-card-subtitle>
        <mat-card-subtitle
          *ngIf="subscription.validDate"
          [innerHTML]="translationService.getTranslation('period') + ': ' +
            (subscription.validDate.validFrom | date: translationService.getTranslation('dateFormat')) + ' - ' +
            ((subscription.validDate.validUntil) ? (subscription.validDate.validUntil | date: translationService.getTranslation('dateFormat')) : translationService.getTranslation('subscription_endless'))">
        </mat-card-subtitle>
      </mat-card-content>
    </mat-card>

    <div class="revocation-edit__description mt-3 col-12">
      <p [innerHTML]="translationService.getTranslation('revocation_edit_description')"></p>
    </div>

    <form [formGroup]="confirmForm" (ngSubmit)="onSubmit()" class="revocation-edit__form mt-3">
      <div class="revocation-edit__confirm col-12">
        <mat-checkbox formControlName="confirmed" class="revocation-edit__checkbox" required>
          <span [innerHTML]="translationService.getTranslation('revocation_confirm_label')"></span>
        </mat-checkbox>
        <p class="text-danger mt-1"
           *ngIf="confirmForm.get('confirmed').hasError('required') && confirmForm.get('confirmed').touched"
           [innerHTML]="translationService.getTranslation('revocation_confirm_required')"></p>
      </div>

      <mat-card-actions class="revocation-edit__actions mt-3">
        <button ngSkipHydration mat-raised-button color="primary"
                type="submit"
                class="revocation-edit__submit-btn me-2"
                [disabled]="confirmForm.invalid"
                [innerHTML]="translationService.getTranslation('button_revocation_submit')">
        </button>
        <button ngSkipHydration mat-button
                type="button"
                class="revocation-edit__cancel-btn"
                (click)="onCancel()"
                [innerHTML]="translationService.getTranslation('button_cancel')">
        </button>
      </mat-card-actions>
    </form>
  </ng-container>
</div>
